var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427319390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4802"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631364",
    x: 7,
    y: 2,
    width: 6,
    height: 12,
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631363",
    x: 1.43329,
    y: 2.43329,
    width: 6.46667,
    height: 11.1333,
    fill: "white",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631365",
    x: 0.5,
    y: 1.5,
    width: 1.8,
    height: 1.8,
    fill: "white",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631368",
    x: 7.03333,
    y: 1.5,
    width: 1.8,
    height: 1.8,
    fill: "white",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631366",
    x: 0.5,
    y: 12.7,
    width: 1.8,
    height: 1.8,
    fill: "white",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631367",
    x: 7.03333,
    y: 12.7,
    width: 1.8,
    height: 1.8,
    fill: "white",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0733 11.6L10.1067 9.416L9 11.04V6L12.7333 9.08H10.84L11.8 11.243L11.0733 11.6Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInver);
export default __webpack_public_path__ + "static/media/inver.524029624a298ff10032264f931aefef.svg";
export { ForwardRef as ReactComponent };